function ensureProductCardModal(modalId) {
  const template = document.querySelector(`template[data-pbh-modal-template="${modalId}"]`);
  if (!template || document.getElementById(modalId)) return document.getElementById(modalId);

  const fragment = template.content.cloneNode(true);
  document.body.appendChild(fragment);
  const dialog = document.getElementById(modalId);

  dialog?.querySelectorAll('[data-pbh-modal-close]').forEach((button) => {
    button.addEventListener('click', () => closeProductCardModal(dialog));
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeProductCardModal(dialog);
  });

  dialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeProductCardModal(dialog);
  });

  return dialog;
}

function openProductCardModal(modalId) {
  const dialog = ensureProductCardModal(modalId);
  dialog?.showModal();
  document.body.classList.add('overflow-hidden');
}

function closeProductCardModal(dialog) {
  dialog?.close();
  document.body.classList.remove('overflow-hidden');
}

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-pbh-modal-open]');
  if (openButton) {
    let modalId = openButton.getAttribute('data-pbh-modal-target');
    if (!modalId) {
      const card = openButton.closest('[data-pbh-card-modal]');
      modalId = card?.getAttribute('data-pbh-card-modal') || '';
    }
    if (modalId) openProductCardModal(modalId);
    return;
  }

  const navigateButton = event.target.closest('[data-pbh-navigate]');
  if (navigateButton) {
    const target = navigateButton.getAttribute('data-pbh-navigate');
    if (target) {
      const url = new URL(target, window.location.origin);
      window.location.assign(`${url.pathname}${url.search}`);
    }
  }
});
